import { type FC } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';

import { FeatureFlagIdentity } from '@/feature-flags';
import { BreadcrumbProvider } from '@/features/breadcrumb/use-breadcrumb-context';
import { RootLayout } from '@/layouts/root-layout';
import { MonitoringIdentity } from '@/monitoring';
import { DemoModeProvider } from '@/util/demo-mode';

export const RootPage: FC = () => {
  return (
    <BreadcrumbProvider>
      <DemoModeProvider>
        {/* Below UserGuard, so the user is loaded. */}
        <FeatureFlagIdentity />
        <MonitoringIdentity />
        {/* The window is the page's scroller, and a client-side navigation leaves
            it where it was. This puts a new page at the top and restores the old
            position on back and forward. Query-only writes opt out with
            preventScrollReset, so a filter change does not jump the page. */}
        <ScrollRestoration />
        <RootLayout>
          <Outlet />
        </RootLayout>
      </DemoModeProvider>
    </BreadcrumbProvider>
  );
};
